import { createContext } from 'react';
import { AdditionalPageableOfferStore } from '@gp/offer';

const defaultValue: any = {};
export const AdditionalPageableStoreContext = createContext<AdditionalPageableOfferStore>(defaultValue);